import { render } from "./FeaturesItem.vue?vue&type=template&id=e91e689e&scoped=true&ts=true"
import script from "./FeaturesItem.vue?vue&type=script&lang=ts"
export * from "./FeaturesItem.vue?vue&type=script&lang=ts"

import "./FeaturesItem.vue?vue&type=style&index=0&id=e91e689e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e91e689e"]])

export default __exports__